import { createFileRoute } from '@tanstack/react-router';
import { RouteStub } from '@/components/shared/RouteStub';

export const Route = createFileRoute('/invite/$invitationToken')({
  component: () => (
    <RouteStub
      title="You've been invited"
      phase="Phase 2 — Team"
      detail="Accept an invitation to join an existing chainMuse organization. Token validated against muse_team_invitations on the backend."
    />
  ),
});
